export const TMS = [
    {
        name: 'portpro',
        slug: 'PortPro',
    },
];
